/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, {
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from 'react';
import Paper from '@material-ui/core/Paper';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { Box, fade } from '@material-ui/core';
import DateNavigatorReports from '../../components/filters/DateNavigatorReports';
import { bgimage } from '../constants';
import PageLayout from '../shared/PageLayout';
import PopupFormOperationView from '../shared/PopupFormOperationView';
import TabsList from '../components/TabsList';
import useCompany from '../../hooks/useCompany';
import { getStoreItem, setStoreItem } from '../../store';
import { SalesContext } from '../../contexts';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { hrReducer, initHRContext } from '../../contexts/hr/salesReducer';
import HRContext from '../../contexts/hr';
import WorkTickets from './WorkTickets';
import Employees from '../shared/Employees';
import {
  EmployeeContext,
  employeeReducer,
  initEmployeeContext,
} from '../../contexts/managment';
import Hritems from './Hritems';
import Salaryitems from './Salaryitems';
import SalaryPayments from './SalaryPayments';
import Vacations from './Vacations';
import Attendance from './WorkReport';
import StartWork from './StartWork';
import EndService from './EndService';

export default function HROperations({
  isRTL,
  words,
  user,
  theme,
  menuitem,
  formgroup,
  drawerWidth,
}: any) {
  const [start, setStart] = useState<any>(null);
  const [end, setEnd] = useState<any>(null);

  const [item, setItem] = useState(null);
  const [openItem, setOpenItem] = useState(false);

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const workticketref: any = useRef();
  const hritemref: any = useRef();
  const employeeref: any = useRef();

  const { height, width } = useWindowDimensions();
  const { company } = useCompany();

  const hrStoreState = getStoreItem('hrStore', initHRContext);
  const [hrStore, hrDispatch] = useReducer(
    hrReducer,
    hrStoreState ? hrStoreState : initHRContext,
  );
  const {
    state: { currentDate, currentViewName, endDate },
    dispatch,
  } = useContext(HRContext);

  const employeeStoreState = getStoreItem('employeeStore', initEmployeeContext);
  const [employeeStore, employeeDispatch] = useReducer(
    employeeReducer,
    employeeStoreState ? employeeStoreState : initEmployeeContext,
  );
  useEffect(() => {
    setStoreItem('employeeStore', employeeStore);
  }, [employeeStore]);

  const currentViewNameChange = (e: any) => {
    dispatch({ type: 'setCurrentViewName', payload: e.target.value });
  };
  const currentDateChange = (curDate: any) => {
    dispatch({ type: 'setCurrentDate', payload: curDate });
  };

  const endDateChange = (curDate: any) => {
    dispatch({ type: 'setEndDate', payload: curDate });
  };

  useEffect(() => {
    setStoreItem('hrStore', hrStore);
  }, [hrStore]);

  const onCloseItem = () => {
    setOpenItem(false);
    setItem(null);
  };

  const handleSelect = (item: any) => {
    navigate(item?.path);
  };

  const refresh = () => {
    if (pathname?.includes('worktickts')) {
      workticketref?.current?.refresh();
    }
    if (pathname?.includes('employees')) {
      employeeref?.current?.refresh();
    }
  };
  const bgcolor = '#23A46C08';

  return (
    <PageLayout
      menuitem={menuitem}
      isRTL={isRTL}
      words={words}
      theme={theme}
      refresh={refresh}
      bgcolor={bgcolor}
      bgimage={bgimage}
      width={width - drawerWidth}
    >
      <Box
        style={{
          height: height - 50,
          overflow: 'auto',
        }}
      >
        <Box
          display="flex"
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginRight: 50,
            marginLeft: 50,
            marginTop: 5,
          }}
        >
          <DateNavigatorReports
            setStart={setStart}
            setEnd={setEnd}
            currentDate={currentDate}
            currentDateChange={currentDateChange}
            currentViewName={currentViewName}
            currentViewNameChange={currentViewNameChange}
            endDate={endDate}
            endDateChange={endDateChange}
            views={[1, 7, 30, 365, 1000]}
            isRTL={isRTL}
            words={words}
            theme={theme}
          ></DateNavigatorReports>
        </Box>
        <Paper
          elevation={5}
          style={{
            borderRadius: 25,
            margin: 25,
            marginTop: 5,
            width: width - drawerWidth - 50,
            height: height - 135,
          }}
        >
          <TabsList
            handleSelect={handleSelect}
            isRTL={isRTL}
            list={formgroup}
            theme={theme}
            width={width - drawerWidth - 50}
            color={fade(theme?.palette?.secondary?.main, 0.2)}
            pathname={pathname}
          ></TabsList>
          <Paper
            style={{
              display: 'flex',
              height: height - 185,
              overflow: 'auto',
              borderBottomLeftRadius: 25,
              borderBottomRightRadius: 25,
            }}
          >
            <Routes>
              <Route
                index
                element={<Navigate to={formgroup?.[0]?.path} replace />}
              />
              <Route
                path={'attendance'}
                element={
                  <SalesContext.Provider
                    value={{ state: hrStore, dispatch: hrDispatch }}
                  >
                    <WorkTickets
                      ref={workticketref}
                      start={start}
                      end={end}
                      isRTL={isRTL}
                      words={words}
                      theme={theme}
                      company={company}
                      drawerWidth={drawerWidth}
                    ></WorkTickets>
                  </SalesContext.Provider>
                }
              />
              <Route
                path={'overtime'}
                element={
                  <SalesContext.Provider
                    value={{ state: hrStore, dispatch: hrDispatch }}
                  >
                    <Hritems
                      ref={hritemref}
                      start={start}
                      end={end}
                      isRTL={isRTL}
                      words={words}
                      theme={theme}
                      company={company}
                      drawerWidth={drawerWidth}
                    ></Hritems>
                  </SalesContext.Provider>
                }
              />
              <Route
                path={'workreport'}
                element={
                  <SalesContext.Provider
                    value={{ state: hrStore, dispatch: hrDispatch }}
                  >
                    <Attendance
                      ref={hritemref}
                      start={start}
                      end={end}
                      isRTL={isRTL}
                      words={words}
                      theme={theme}
                      company={company}
                      drawerWidth={drawerWidth}
                    ></Attendance>
                  </SalesContext.Provider>
                }
              />
              <Route
                path={'salaryitems'}
                element={
                  <SalesContext.Provider
                    value={{ state: hrStore, dispatch: hrDispatch }}
                  >
                    <Salaryitems
                      ref={hritemref}
                      start={start}
                      end={end}
                      isRTL={isRTL}
                      words={words}
                      theme={theme}
                      company={company}
                      drawerWidth={drawerWidth}
                      currentViewName={currentViewName}
                      currentViewNameChange={currentViewNameChange}
                      user={user}
                    ></Salaryitems>
                  </SalesContext.Provider>
                }
              />
              <Route
                path={'salarypayments'}
                element={
                  <SalesContext.Provider
                    value={{ state: hrStore, dispatch: hrDispatch }}
                  >
                    <SalaryPayments
                      ref={hritemref}
                      start={start}
                      end={end}
                      isRTL={isRTL}
                      words={words}
                      theme={theme}
                      company={company}
                      drawerWidth={drawerWidth}
                    ></SalaryPayments>
                  </SalesContext.Provider>
                }
              />
              <Route
                path={'vacations'}
                element={
                  <SalesContext.Provider
                    value={{ state: hrStore, dispatch: hrDispatch }}
                  >
                    <Vacations
                      ref={hritemref}
                      start={start}
                      end={end}
                      isRTL={isRTL}
                      words={words}
                      theme={theme}
                      company={company}
                      drawerWidth={drawerWidth}
                    ></Vacations>
                  </SalesContext.Provider>
                }
              />
              <Route
                path={'employees'}
                element={
                  <EmployeeContext.Provider
                    value={{ state: employeeStore, dispatch: employeeDispatch }}
                  >
                    <Employees
                      ref={employeeref}
                      isRTL={isRTL}
                      words={words}
                      theme={theme}
                      company={company}
                    ></Employees>
                  </EmployeeContext.Provider>
                }
              />
              <Route
                path={'startwork'}
                element={
                  <SalesContext.Provider
                    value={{ state: hrStore, dispatch: hrDispatch }}
                  >
                    <StartWork
                      isRTL={isRTL}
                      words={words}
                      theme={theme}
                      company={company}
                    ></StartWork>
                  </SalesContext.Provider>
                }
              />
              <Route
                path={'endservice'}
                element={
                  <SalesContext.Provider
                    value={{ state: hrStore, dispatch: hrDispatch }}
                  >
                    <EndService
                      isRTL={isRTL}
                      words={words}
                      theme={theme}
                      company={company}
                    ></EndService>
                  </SalesContext.Provider>
                }
              />
            </Routes>
          </Paper>
        </Paper>
        <PopupFormOperationView
          open={openItem}
          onClose={onCloseItem}
          row={item}
          theme={theme}
          isRTL={isRTL}
          words={words}
          user={user}
        ></PopupFormOperationView>
      </Box>
    </PageLayout>
  );
}
